export const convertVidecam = (item) => {
  if (!item) return
  let list = {}
  for (let i = 0; i < item.length; i++) {
    const { id, ...props } = item[i]
    list = { ...list, [id]: { id, ...props } }
  }
  return list
}
